"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = VideoPlaceholder;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_placeholder.scss");

var TEXT_SIZE = {
  MEDIUM: 1e3,
  SMALL: 600
};

function VideoPlaceholder(a) {
  var b = a.text,
      c = a.icon,
      d = a.iconColor,
      e = a.subtitle,
      f = a.darkTheme,
      g = a.className,
      h = a.size.width;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("video-placeholder", {
      "video-placeholder--dark": f
    }, g)
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "video-placeholder__icon",
    name: c,
    color: d,
    animated: !0
  }), _react["default"].createElement("div", {
    className: "video-placeholder__text"
  }, _react["default"].createElement(_uiKit.Text, {
    heading3: h >= TEXT_SIZE.MEDIUM,
    heading4: h < TEXT_SIZE.MEDIUM && h >= TEXT_SIZE.SMALL,
    heading5: h < TEXT_SIZE.SMALL,
    noMargin: "top",
    darkTheme: !0
  }, b), e ? _react["default"].createElement(_uiKit.Text, {
    label: h < TEXT_SIZE.SMALL,
    darkTheme: !0
  }, e) : null));
}

VideoPlaceholder.defaultProps = {
  text: "Preparing",
  icon: "rushedit",
  iconColor: "monkey"
};